// Przestrzeń nazw 'phoneNumbers': numery przychodzące (Twilio) i wyszukiwanie numerów do zakupu.
//
// VERIFY: cały plik, brak w mockupie. Mockup pokazuje jedynie „Numer telefonu asystenta"
// (jedna wartość w Ustawieniach), a u nas są dwie zakładki z tabelami i zakupem numeru.
export default {
  tabs: {
    incoming: 'Numery przychodzące',
    search: 'Wyszukaj i kup',
  },
  // Wspólne dla tabeli numerów przychodzących i wyników wyszukiwania.
  columns: {
    phoneNumber: 'Numer telefonu',
    friendlyName: 'Przyjazna nazwa',
    voiceUrl: 'URL połączeń głosowych',
    smsUrl: 'URL SMS',
    assignedInCrm: 'Przypisany w CRM',
    dateCreated: 'Data utworzenia',
    location: 'Lokalizacja',
    capabilities: 'Funkcje',
    action: 'Akcja',
  },
  search: {
    fields: {
      country: 'Kraj',
      type: 'Typ',
      areaCode: 'Numer kierunkowy',
      contains: 'Zawiera',
    },
    placeholders: {
      areaCode: 'np. 415',
      contains: 'np. 555',
    },
    // Klucze to kody krajów wysyłane do API.
    countries: {
      US: 'Stany Zjednoczone',
      CA: 'Kanada',
      GB: 'Wielka Brytania',
    },
    // Klucze to wartości `number_type` z API.
    numberTypes: {
      local: 'Lokalny',
      toll_free: 'Bezpłatny',
      mobile: 'Komórkowy',
    },
    capabilities: {
      voice: 'Połączenia',
      sms: 'SMS',
      mms: 'MMS',
    },
    buy: 'Kup',
    confirm: {
      title: 'Potwierdź zakup',
      text: 'Czy na pewno aktywować numer {{phoneNumber}}? Spowoduje to naliczenie opłat na koncie Twilio.',
      confirmButton: 'Kup numer',
    },
    empty: {
      prompt: 'Wyszukaj dostępne numery',
      noResults: 'Nie znaleziono numerów',
    },
    messages: {
      provisioned: 'Numer {{phoneNumber}} został aktywowany',
      provisionFailed: 'Nie udało się aktywować numeru. Spróbuj ponownie.',
    },
  },
} as const;
